import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step18: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "buyingPlace",
      questionData: questions[0],
      label: "¿Dónde realiza la compra de alimentos para el hogar?",
      elementType: ElementType.Checkbox,
      checkboxStyle: {
        minWidth: "300px",
        margin: "0 1rem",
      },
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "buyingFrequency",
      questionData: questions[1],
      elementType: ElementType.Select,
      label: "¿Con qué frecuencia realiza la compra de alimentos para el hogar?",
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "foodConsumed",
      questionData: questions[2],
      elementType: ElementType.Checkbox,
      label: "¿Qué es lo que más consumen en el hogar?",
      checkboxStyle: {
        minWidth: "350px",
        margin: "0 1rem",
      },
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "isFoodGrown",
      questionData: questions[3],
      elementType: ElementType.Radio,
      label: "¿Produce algún tipo de alimento para autoconsumo?",
    },
    {
      key: 4,
      formik,
      visible: true,
      name: "watterAvailability",
      questionData: questions[4],
      elementType: ElementType.Select,
      label: "¿Con qué frecuencia dispone de agua para el consumo humano en el hogar?",
    },
    {
      key: 5,
      formik,
      visible: true,
      name: "completedFood",
      questionData: questions[5],
      elementType: ElementType.Select,
      label: "¿Cuántas comidas completas (desayuno, almuerzo, cena) consume al día?",
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Cuéntenos sobre sus hábitos de consumo
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step18;
